import { fetchApiData, updateApiData } from "../../../utils/utils";

export const stripeDecode = async (appInfo, sessionId) => {
  const pubId = appInfo?.projectDetails?.projectConfig?.pubid;
  const countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  const params = {
    pubid: pubId,
    sessionId: sessionId,
    country_code: countryCode,
  };
  const api = "subscription/stripe/details";
  return await fetchApiData(appInfo, api, params);
};

export const updatePayment = async (
  appInfo,
  subscription,
  modeOfPayment,
  status,
  isUpgrade,
  subscriptionId,
) => {
  const couponId = localStorage.getItem("couponId");
  const orginalAmount = localStorage.getItem("selectedAmount");
  const deviceType = localStorage.getItem("deviceType");
  const selectedSubId = localStorage.getItem("selectedSubId");
  const previousSubId = localStorage.getItem("previousSubId");
  const userId = localStorage.getItem("userId");
  const ideabizPhone = localStorage.getItem("ideabizPhone");
  const s2s_transaction_id = localStorage.getItem("s2s_transaction_id");

  let transactionType = 1;
  if (isUpgrade === true) {
    transactionType = 6;
  }

  const resolvedSubscriptionId = ["stripe", "paypal"].includes(modeOfPayment) ? (subscriptionId ?? selectedSubId) : selectedSubId;

  let values = {
    device_id: appInfo?.projectDetails?.device_id,
    transaction_type: transactionType,
    subscription_id: resolvedSubscriptionId,
    mode_of_payment: modeOfPayment,
    status: status,
    uid: userId,
    amount: orginalAmount,
    receiptid: subscription,
    pubid: appInfo?.projectDetails?.projectConfig?.pubid,
    device_type: deviceType,
    ideabiz_phone: ideabizPhone
  };
  if (couponId) {
    values.coupon_id = couponId;
  }
  if (isUpgrade === true) {
    values.previous_subscription_id = previousSubId;
  }
  if (s2s_transaction_id) {
    values.s2s_transaction_id = s2s_transaction_id;
  }

  const location = {
    path: "updatePayment",
    values: values,
  };

  const api =
    isUpgrade === true
      ? "subscription/upgrade"
      : "subscription/updateTransaction";
  const response = await updateApiData(appInfo, api, location);
  if (response?.status === 200) {
    clearData();
  }
  return response;
};

export const paypalSubscription = async (appInfo, subId) => {
  const params = {
    sub_id: subId,
  };
  const api = "subscription/paypal/verify";
  return await fetchApiData(appInfo, api, params);
};

export const updateBundlePayment = async (
  appInfo,
  bundleId,
  paymentMethod,
  paymentRef,
  pricePaid,
  currencyId
) => {
  const values = {
    bundle_id: bundleId,
    payment_method: paymentMethod,
    payment_ref: paymentRef,
    price: pricePaid,
    currency_id: currencyId,
  };

  const location = {
    path: "bundlePurchase",
    values,
  };

  return await updateApiData(appInfo, "bundles/purchase", location);
};

const clearData = () => {
  localStorage.removeItem("couponId");
  localStorage.removeItem("previousSubId");
  localStorage.removeItem("selectedSubId");
  localStorage.removeItem("selectedAmount");
}
